import { render, staticRenderFns } from "./systemDoorItem.vue?vue&type=template&id=4ccdd6f8&"
import script from "./systemDoorItem.vue?vue&type=script&lang=ts&"
export * from "./systemDoorItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports